module.exports = __webpack_public_path__ + "static/media/how-works.d9213c7c.png";